export default __webpack_public_path__ + "img/3c6844daba8236a58328abd4bd565aba.svg";